<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 7px;">发布时间</span>
        <el-date-picker v-model="timevalue" size="small" type="daterange"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <input-search placeholder="政策标题" @search="searchKey" />
    </div>
    <div class="search-line">
      <div class="btn-box">
        <input-select selectTitle="政策类型" :selectKey="'zcType'" selectWidth="140px" :selectData="zcTypeList" @search="search" style="margin-right: 10px;"/>
        <input-select selectTitle="级别" :selectKey="'areaName'" selectWidth="140px" :selectData="areaNameList" @search="search" style="margin-right: 10px;"/>
      </div>
      <input-select selectTitle="分类" :selectKey="'type1Name'" selectWidth="200px" :selectData="type1NameList" @search="search" style="margin-right: 10px;"/>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :deleteTipInfo="'是否确认删除政策？'" @toCurrentPage="toCurrentPage" @lookOver="lookOver" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" tableOperationWidth="120px"/>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/EnterpriseFavour'
import {errorHandler} from '../../../utils/errorHandler'
import {nAlert, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb},
  name: 'party-information-manage',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '惠企服务',
        name: 'latest-policy-manage'
      }, {
        value: '最新政策'
      }],
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      timevalue: [],
      operationArr: ['current'],
      tableHead: [{
        prop: 'title',
        label: '政策标题'
      }, {
        prop: 'publishDept',
        label: '发文单位'
      }, {
        prop: 'information',
        isLookOver: true,
        label: '政策原文'
      }, {
        prop: 'publishTime',
        label: '发文日期',
        width: '120'
      }, {
        prop: 'type1Name',
        label: '政策分类',
        width: '100'
      }, {
        prop: 'areaName',
        label: '政策级别',
        width: '100'
      }, {
        prop: 'businessName',
        label: '支持产业',
        width: '180'
      }, {
        prop: 'viewNumber',
        label: '浏览量',
        width: '100'
      }, {
        prop: 'collectNumber',
        label: '收藏量',
        width: '100'
      }],
      tableData: [],
      total: 0,
      selectionArr: [],
      zcTypeList: [
        {
          key: '',
          label: '全部'
        }, {
          key: '1',
          label: '指导意见类'
        }, {
          key: '0',
          label: '申报执行类'
        }
      ],
      areaNameList: [
        {
          key: '',
          label: '全部'
        }, {
          key: '国家',
          label: '国家'
        }, {
          key: '浙江省',
          label: '浙江省'
        }, {
          key: '杭州市',
          label: '杭州市'
        }, {
          key: '富阳区',
          label: '富阳区'
        }, {
          key: '滨江区',
          label: '滨江区'
        }, {
          key: '江干区',
          label: '江干区'
        }, {
          key: '余杭区',
          label: '余杭区'
        }, {
          key: '上城区',
          label: '上城区'
        }, {
          key: '淳安区',
          label: '淳安区'
        }, {
          key: '钱塘新区',
          label: '钱塘新区'
        }, {
          key: '桐庐县',
          label: '桐庐县'
        }, {
          key: '临安区',
          label: '临安区'
        }, {
          key: '下城区',
          label: '下城区'
        }, {
          key: '萧山区',
          label: '萧山区'
        }, {
          key: '建德市',
          label: '建德市'
        }, {
          key: '西湖区',
          label: '西湖区'
        }, {
          key: '拱墅区',
          label: '拱墅区'
        }
      ],
      type1NameList: [
        {
          key: '',
          label: '全部'
        }, {
          key: '财政补助',
          label: '财政补助'
        }, {
          key: '资金扶持',
          label: '资金扶持'
        }, {
          key: '防疫政策汇编',
          label: '防疫政策汇编'
        }, {
          key: '产业发展',
          label: '产业发展'
        }, {
          key: '资质认定',
          label: '资质认定'
        }, {
          key: '财税政策',
          label: '财税政策'
        }, {
          key: '创业扶持',
          label: '创业扶持'
        }, {
          key: '知识产权',
          label: '知识产权'
        }, {
          key: '降低企业用能用地成本',
          label: '降低企业用能用地成本'
        }, {
          key: '产业政策',
          label: '产业政策'
        }, {
          key: '疫情防控',
          label: '疫情防控'
        }, {
          key: '财政支持',
          label: '财政支持'
        }, {
          key: '降低企业人工成本',
          label: '降低企业人工成本'
        }, {
          key: '费金减免',
          label: '费金减免'
        }, {
          key: '降低企业融资成本',
          label: '降低企业融资成本'
        }, {
          key: '降低企业制度性交易成本',
          label: '降低企业制度性交易成本'
        }, {
          key: '税收优惠',
          label: '税收优惠'
        }, {
          key: '其他',
          label: '其他'
        },
      ],
      requestData: {
        searchKey: '',
        pageSize: 10,
        pageNum: 1,
        zcType: '',
        areaName: '',
        type1Name: '',
        startTime: '',
        endTime: '',
      },
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getCreatTime()
  },
  methods: {
    getCreatTime () {
      let nowDate = new Date
      let year = nowDate.getFullYear()
      let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
      let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()

      let lastDate = new Date(nowDate - 1000 * 60 * 60 * 24 * 30);//最后30天可以更改，意义：是获取多少天前的时间
      let lastY = lastDate.getFullYear();
      let lastM = (lastDate.getMonth() + 1) < 10 ? '0' + (lastDate.getMonth() + 1) : (lastDate.getMonth() + 1)
      let lastD = lastDate.getDate() < 10 ? '0' + lastDate.getDate() : lastDate.getDate()
      this.timevalue[0] = lastY + '-' + lastM + '-' + lastD
      this.timevalue[1] = year + '-' + month + '-' + date
      this.getPage()
    },
    getPage () {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || ''
        this.requestData.endTime = this.timevalue[1] || ''
      } else {
        this.requestData.startTime = ''
        this.requestData.endTime = ''
      }
      this.$axios.post(api.getNewestPolicyPage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map(v => {})
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取失败'))
    },
    search (v) {
      this.requestData.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey (v) {
      this.requestData.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.requestData.pageNum = data[0]
      this.requestData.pageSize = data[1]
      this.getPage()
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    toCurrentPage (code) {
      this.$router.push({
        path: `/latest_policy_current/${code}`
      })
    },
    lookOver (data) {
      if (data.indexOf('doc') === -1) {
        window.open(data, '_blank')
      } else {
        window.open('http://view.officeapps.live.com/op/view.aspx?src=' + data, '_blank')
      }
    }
  },
  watch: {
    timevalue (val) {
      this.getPage()
    }
  }
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/EnterpriseFavour/LatestPolicy/LatestPolicyManage.vue